<div class="zk-w-full zk-h-full superset">
	<div  *ngIf="loading" class="zk-m-10 zk-text-center">
		<section class="zk-m-10 zk-text-center">
			<freud-loader
				alt="loading gif"
				class="zk-mb-2"
				size="lg"
				[bgColor]="false"
			></freud-loader>
		</section>
		<div *ngIf="messageLoading" class="zk-items-center">
			<div [innerHTML]="messageLoading"></div>
		</div>
	</div>

	<div
		#supersetDiv
		class="zk-w-full zk-flex-col zk-flex zk-relative"
		[style.height.px]="heightIframePx"
		[style.height.vh]="heightIframeVh"
	></div>

	<div
		class="zk-flex zk-justify-center zk-w-full zk-absolute zk-top-28"
		*ngIf="hasError"
	>
		😥 Erro ao carregar dashboard... Por favor recarregue a página.
	</div>
</div>
